import { render, staticRenderFns } from "./MessagingVueComponent.vue?vue&type=template&id=6119318d&"
import script from "./MessagingVueComponent.vue?vue&type=script&lang=ts&"
export * from "./MessagingVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MessagingVueComponent.vue?vue&type=style&index=0&id=6119318d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports